import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Navbar from '../navbar';
import ReportNavbar from '../navbar/ReportNavbar';
import SettingNavbar from '../navbar/SettingNavbar';
import {
  CMDKOverLayDiv,
  Content,
  GroupWorkspaceLoading,
  Headline,
  Icon,
  MainSection,
  ModalHead,
  SideBarListMain
} from './styles';
import { VercelCMDK } from '../vercel/vercel';
import { useHotkeys } from 'react-hotkeys-hook';
import { isEmpty } from 'lodash';
import Responsivnavbar from '../navbar/responsiveNavbar';
import ModalCustom from '../models/modal';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { isDev, isElectronApp, isIpad, isMediaRecordingSupported } from '../../helpers/common';
import SnapRecordModal from '../models/snapRecordModal';
import { useMobileDevice } from '../../global/useMobile';
import { ContactUsModal } from '../models/contactUsmodal';
import { SuccessFullModal } from '../models/contactUsmodal/successfullmessagemodal';
import { useDispatch } from 'react-redux';
import UserModal from '../models/userModal';
import { captureException } from '../../services/logService';
import Avatar from '../avatar/Avatar';
import { WorkspaceInterface } from '../../interfaces/WorkspaceInterface';
import { setCurrentWorkspace } from '../../actions/workspaceActions';
import { rootStore } from '../../mobx/rootStore';
import { setWorkspaceIdInAxios } from '../../helpers/authTokenHelpers';
import { workspaceSetAnalytics } from '../../services/analyticsService';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { updateUserPreference } from '../../helpers/firebaseHelper';
import { clearPreviousWorkspaceData } from '../../services/baseServices';
import { appInit } from '../../services/appService';
import { observer } from 'mobx-react-lite';
import { DESKTOP_VIEW, TABS_COMMAND_K_ID } from '../../global/constants';
import CreateTaskModalV2 from '../models/createTaskModal/createTaskModalV2';
import WorkSpaceLoading from '../loading/workSpaceLoading';
import CreateNewProjectModalV2 from '../models/createNewProjectModal/createProjectModelV2';
import { loadInboxData } from '../../services/inboxServices';
import { convertQueryToWordsCollection } from '../../services/universalSearch';
import { toJS } from 'mobx';
interface Props {
  children?: any;
  isInbox?: boolean;
  Inbox?: boolean;
  isPosition?: boolean;
  isMessageBox?: boolean;
  isPadding?: boolean;
  isNewDocPage?: boolean;
  isTaskDetailPreviewOpen?: boolean;
  isOverflowHidden?: boolean;
}

const AppLayout: React.FC<Props> = (Props) => {
  const {
    isInbox = false,
    children,
    Inbox = false,
    isPosition = false,
    isMessageBox = false,
    isPadding = false,
    isNewDocPage = false,
    isTaskDetailPreviewOpen = false,
    isOverflowHidden = false
  } = Props;
  //States
  const [searchBox, setSearchBox] = useState(false);
  const [isOpenProjectModal, setIsOpenProjectModal] = useState(false);
  const [isOpenSnapModal, setIsOpenSnapModal] = useState(false);
  const [isOpenTaskModal, setIsOpenTaskModal] = useState(false);
  const [openContactUsModal, setOpenContactUsModal] = useState(false);
  const [isSuccessfulModalOpen, setIsSuccessfulModalOpen] = useState(false);
  const [isOpenUserModal, setIsOpenUserModal] = useState(false);
  // const [activeWorkspace, setActiveWorkspace] = useState<string | null>(null);

  // Mobx store
  const { appStore, workspaceStore } = rootStore || {};
  const { extractedDesktopView, isAppLoading, isNavbarShow } = appStore || {};
  const { currentWorkspace, workspaceList } = workspaceStore || {};
  //other variables
  const isMobile = useMobileDevice();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  // useEffect(() => {
  //   const handleScroll = (event: Event) => {
  //     const target = event.target as HTMLElement;
  //     const isScrolled = target.scrollTop > 15;
  //     rootStore.appStore.setIsPageScrolled(isScrolled);
  //   };

  //   // Function to add scroll listeners to all scrollable elements
  //   const addScrollListeners = () => {
  //     const scrollableElements = document.querySelectorAll('*');
  //     scrollableElements.forEach((element) => {
  //       if (
  //         element instanceof HTMLElement &&
  //         (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth)
  //       ) {
  //         element.addEventListener('scroll', handleScroll);
  //       }
  //     });
  //   };

  //   // Initial setup
  //   addScrollListeners();

  //   // Set up MutationObserver to detect new elements
  //   const observer = new MutationObserver((mutations) => {
  //     mutations.forEach((mutation) => {
  //       if (mutation.addedNodes.length) {
  //         addScrollListeners();
  //       }
  //     });
  //   });

  //   // Start observing the document body for changes
  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });

  //   return () => {
  //     // Clean up scroll listeners
  //     const scrollableElements = document.querySelectorAll('*');
  //     scrollableElements.forEach((element) => {
  //       if (element instanceof HTMLElement) {
  //         element.removeEventListener('scroll', handleScroll);
  //       }
  //     });
  //     // Disconnect the observer
  //     observer.disconnect();
  //   };
  // }, []);

  useEffect(() => {
    rootStore.appStore.setIsPageScrolled(false);
  }, [location.pathname]);

  useHotkeys(['ctrl+k', 'meta+k'], async (event) => {
    event.preventDefault();
    const { projects, tasks, users } = convertQueryToWordsCollection('', TABS_COMMAND_K_ID.ALL);
    rootStore.appStore.setUniversalSearchData({ projects, tasks, users });
    setSearchBox(true);
  });
  useHotkeys('esc', async (event) => {
    event.preventDefault();
    setSearchBox(false);
  });

  const closeCmdPopup = useCallback(() => {
    if (!isMobile) {
      setSearchBox(false);
    }
  }, [isMobile]);

  const handleOverlayClick = useCallback(
    (e: any) => {
      if (isMobile) {
        return;
      }
      if (!isEmpty(e.target.className)) {
        setSearchBox(false);
      } else {
        setSearchBox(true);
      }
    },
    [isMobile]
  );

  const onClickCreateProject = useCallback(() => {
    setIsOpenProjectModal(true);
  }, []);

  const closeProjectModal = useCallback(() => {
    setIsOpenProjectModal(false);
  }, []);

  const onClickCreateTask = useCallback(() => {
    setIsOpenTaskModal(true);
  }, []);

  const openSnapModal = useCallback(() => {
    setIsOpenSnapModal(true);
  }, []);

  const closeSnapModal = useCallback(() => {
    setIsOpenSnapModal(false);
  }, []);

  const closeTaskModal = useCallback(() => {
    setIsOpenTaskModal(false);
  }, []);

  const onCloseContactUsModal = useCallback(() => {
    setOpenContactUsModal(false);
  }, []);

  const onCloseSuccessfullModal = useCallback(() => {
    setIsSuccessfulModalOpen(false);
  }, []);

  const onClickUserPopup = useCallback(() => {
    setIsOpenUserModal(true);
  }, []);

  const onCloseUserModal = useCallback(() => {
    setIsOpenUserModal(false);
  }, []);

  const renderCmdBox = useMemo(() => {
    const isVercelModalOpen = searchBox;
    return (
      isVercelModalOpen && (
        <>
          <CMDKOverLayDiv onClick={handleOverlayClick} />
          <VercelCMDK
            openSnapModal={openSnapModal}
            closePopup={closeCmdPopup}
            openProjectModal={onClickCreateProject}
            openTaskModal={onClickCreateTask}
            openUserModal={onClickUserPopup}
            setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)}
          />
        </>
      )
    );
  }, [
    closeCmdPopup,
    handleOverlayClick,
    onClickCreateProject,
    onClickCreateTask,
    onClickUserPopup,
    openContactUsModal,
    openSnapModal,
    searchBox
  ]);

  const renderNavbar = useCallback(() => {
    if (location.pathname.startsWith('/settings')) {
      if (!isMobile && isNavbarShow) {
        return <SettingNavbar />;
      }
    } else if (location.pathname.startsWith('/report')) {
      if (!isMobile && isNavbarShow) {
        return <ReportNavbar />;
      }
    } else {
      return (
        <>
          {isNavbarShow && (
            <div className='webview'>
              <Navbar setOpenContactUsModal={() => setOpenContactUsModal(!openContactUsModal)} />
            </div>
          )}

          <div className='mobileView'>
            {!location.pathname.startsWith('/projects') &&
            location.pathname !== '/' &&
            !location.pathname.startsWith('/messages') &&
            !location.pathname.startsWith('/timeTracking') &&
            !location.pathname.startsWith('/customer') &&
            !location.pathname.startsWith('/my-tasks') &&
            !location.pathname.startsWith('/search') &&
            !location.pathname.startsWith('/recurring-tasks') &&
            !location.pathname.startsWith('/invoices') &&
            !location.pathname.startsWith('/home') &&
            !location.pathname.startsWith('/snap') &&
            !location.pathname.startsWith('/members') ? (
              <Responsivnavbar />
            ) : (
              ''
            )}
          </div>
        </>
      );
    }
  }, [isMobile, isNavbarShow, location.pathname, openContactUsModal]);

  const selectWorkspace = useCallback(
    async (item: WorkspaceInterface) => {
      try {
        // setLoading(true);
        if (!item?.id || item?.id === currentWorkspace?.id) return;
        rootStore.appStore.setIsAppLoading(true);
        dispatch(setCurrentWorkspace(toJS(item)));
        // const tabStore = rootStore.workspaceStore.workspaces.find((workspace) => workspace.id===item?.id)?.tabsStore;
        // const ref = tabStore?.tabs.find((tab) => tab.id === tabStore?.selectedTabId);
        // history.push(ref?.path || '/');
        rootStore.workspaceStore.setCurrentWorkspace(item);

        setWorkspaceIdInAxios(item?.id);
        workspaceSetAnalytics(item?.id);
        await UserPreferenceSingleton.getInstance().setWorkspace(toJS(item));
        if (!isDev()) await updateUserPreference({ current_workspace_id: item?.id });
        const clearResult = await dispatch(clearPreviousWorkspaceData());
        const initResult = await dispatch(appInit());
        dispatch(loadInboxData());
        const intercomPayload = {
          company: {
            name: item?.name,
            id: item?.id
          }
        };
        if (window && typeof (window as any)?.Intercom === 'function') {
          (window as any).Intercom('update', intercomPayload);
        }
        if ((window as any).posthog) {
          (window as any).posthog.group('Workspace', intercomPayload.company?.id, {
            name: intercomPayload.company?.name
          });
        }
        if (clearResult && initResult) {
          UserPreferenceSingleton.getInstance().setRecentSearch([]);
          history.push('/');
        }
      } catch (e) {
        captureException(e);
        console.log('ERROR', e);
      } finally {
        rootStore.appStore.setIsAppLoading(false);
        // setLoading(false);
      }
    },
    [currentWorkspace?.id, dispatch, history]
  );

  const renderElectronSidebar = useMemo(() => {
    return (
      <SideBarListMain
        disabled={isAppLoading}
        className={isNavbarShow ? 'electron-sidebar' : 'electron-sidebar navbar-hidden'}>
        {workspaceList?.map((workspace) => (
          <div
            key={workspace.id}
            className={`workspace-logo ${currentWorkspace?.id === workspace.id ? 'active' : ''}`}
            onClick={() => selectWorkspace(workspace)}>
            {!isEmpty(workspace?.logoUrl) ? (
              <img src={workspace?.logoUrl} alt='profilePhoto' width={32} height={32} />
            ) : (
              <Avatar imgSrc={workspace?.logoUrl || ''} name={workspace?.name} size={32} isBorderRadius={true} />
            )}
          </div>
        ))}
      </SideBarListMain>
    );
  }, [isAppLoading, currentWorkspace?.id, isNavbarShow, workspaceList, selectWorkspace]);

  return (
    <MainSection
      isInbox={isInbox}
      isMessageBox={isMessageBox}
      isTaskDetailPreviewOpen={isTaskDetailPreviewOpen}
      className={`main-section ${!isNavbarShow && !extractedDesktopView ? 'navbar-extracted-hidden' : ''}${
        extractedDesktopView ? 'extracted-desktop-diff-padding' : 'extracted-desktop-hidden'
      } ${!isNavbarShow ? 'main-navbar-hidden' : 'main-navbar-show'}`}>
      {isElectronApp() && extractedDesktopView === DESKTOP_VIEW.OPEN && renderElectronSidebar}
      {renderCmdBox}
      {isAppLoading ? (
        <GroupWorkspaceLoading extractedDesktopView={extractedDesktopView === DESKTOP_VIEW.OPEN && isElectronApp()}>
          <WorkSpaceLoading />
        </GroupWorkspaceLoading>
      ) : (
        <>
          {renderNavbar()}
          <Content
            Inbox={Inbox}
            isPosition={isPosition}
            isPadding={isPadding}
            isNewDocPage={isNewDocPage}
            isOverflowHidden={isOverflowHidden}
            className={`right-content ${!isNavbarShow ? 'navbar-hidden' : ''}`}
            style={
              isIpad()
                ? {
                    borderRadius: isNavbarShow
                      ? '8px 8px var(--ipad-border-radius) 8px'
                      : '8px 8px var(--ipad-border-radius) var(--ipad-border-radius)'
                  }
                : !isNavbarShow
                ? { borderRadius: '8px' }
                : {}
            }>
            {children}
          </Content>
        </>
      )}
      <ModalCustom open={isOpenProjectModal} onClose={closeProjectModal} width={632}>
        <ModalHead>
          <Headline>Create New Project</Headline>
          <Icon onClick={closeProjectModal}>
            <SVGIcon name='close-icon' width='18' height='18' viewBox='0 0 18 18' fill='none' className='svgIcon' />
          </Icon>
        </ModalHead>
        <CreateNewProjectModalV2 handleCloseModal={closeProjectModal} onClickCancel={closeProjectModal} />
      </ModalCustom>
      <ModalCustom open={isOpenTaskModal} onClose={closeTaskModal} isCreateTask={true}>
        <CreateTaskModalV2 onCancel={closeTaskModal} isFromShortcut={true} />
      </ModalCustom>
      {isMediaRecordingSupported() && (
        <ModalCustom open={isOpenSnapModal} onClose={closeSnapModal} width={258} isZindex={true}>
          <SnapRecordModal handleCloseModal={closeSnapModal} />
        </ModalCustom>
      )}
      {/* contact us Modal */}
      <ModalCustom open={openContactUsModal} onClose={onCloseContactUsModal} width={500}>
        <ContactUsModal
          openSuccessFullModal={() => setIsSuccessfulModalOpen(true)}
          closeContactUsModal={() => setOpenContactUsModal(false)}
        />
      </ModalCustom>
      <ModalCustom open={isSuccessfulModalOpen} onClose={onCloseSuccessfullModal} width={500}>
        <SuccessFullModal onClose={onCloseSuccessfullModal} />
      </ModalCustom>
      <ModalCustom open={isOpenUserModal} onClose={onCloseUserModal} width={280}>
        <UserModal onClose={onCloseUserModal} />
      </ModalCustom>
    </MainSection>
  );
};

export default observer(AppLayout);
